import React from "react";

interface ProgressDotsProps {
  total: number;
  current: number;
}

export const WizardProgressDots: React.FC<ProgressDotsProps> = ({
  total,
  current,
}) => (
  <div className="tlx-panel-wizard-content__progress" aria-hidden="true">
    {Array.from({ length: total }).map((_, i) => {
      const dotClass =
        i === current
          ? "tlx-panel-wizard-content__progress-dot--active"
          : i < current
            ? "tlx-panel-wizard-content__progress-dot--completed"
            : "";
      return (
        <div
          key={i}
          className={`tlx-panel-wizard-content__progress-dot ${dotClass}`}
        />
      );
    })}
  </div>
);
